
const possiblePeriodStatuses = [
    "Open",
    "Concluded",
    "Approved",
    "Rejected",
    "Awaiting Data",
    "Awaiting Approval",
    "Data Submitted",
]


function getPeriodStatus(period) {
    let status = "Open";
    if (possiblePeriodStatuses.includes(period?.status)) status = period?.status;
    if (!["false", "no", "undefined", undefined].includes(period?.complete)) status = "Concluded";
    return status;
}

exports.getPeriodStatus = getPeriodStatus;
exports.possiblePeriodStatuses = possiblePeriodStatuses;